module.exports = __webpack_public_path__ + "static/img/model2-6.c7a38e9c.jpg";